<template>
    <span class="ah-tip" style="vertical-align: middle">
        <el-tooltip placement="top-start" trigger="hover">
            <div slot="content">
                <slot></slot>
                <div v-if="showSecret" style="color: #ffa230; font-size: 12px">
                    {{ secretText }}
                </div>
            </div>
            <template v-if="!icon">
                <img alt="" class="tip-icon" src="@/assets/img/ah-icon-question-outline.svg" @mouseover="onMouseOver" @mouseleave="onMouseLeave" />
            </template>
            <template v-else>
                <i :style="{color: color, display: 'inline-block', margin: '0 5px'}"  :class="icon" @mouseover="onMouseOver" @mouseleave="onMouseLeave"></i>
            </template>
        </el-tooltip>
    </span>
</template>
<script>
export default {
    name: 'ah-tip',
    props: {
        secretText: {
            type: String,
            default: null,
        },
        icon: {
            type: String,
            default: null,
        },
        color: {
            type: String,
            default: '#888888',
        },
    },
    data() {
        return {
            showSecret: false,
        };
    },
    methods: {
        onMouseOver(evt) {
            if (!this.secretText) return;
            if (evt.shiftKey) this.showSecret = true;

            window.addEventListener('keydown', this.onKeyDownListener);
            window.addEventListener('keyup', this.onKeyUpListener);
        },
        onMouseLeave() {
            if (!this.secretText) return;
            this.showSecret = false;
            window.removeEventListener('keydown', this.onKeyDownListener);
            window.removeEventListener('keyup', this.onKeyUpListener);
        },
        onKeyDownListener(evt) {
            if (!evt.shiftKey) return;
            this.showSecret = true;
        },
        onKeyUpListener() {
            this.showSecret = false;
        },
    },
};
</script>
